import { apiUrl } from "../../utils/api";
import { PRIVATE_FETCH_OPTIONS } from "../privacy/privateTransport";
import { isLocalDashboardHost } from "./localDashboard";

// Dashboard requests use the configured API directly, without credentials.
export async function fetchDashboardJson(path, init = {}) {
  const url = new URL(apiUrl(path), window.location.origin);
  if (!isLocalDashboardHost() || !isLocalDashboardHost(url.hostname)) {
    throw new Error("The LLM dashboard is available only on localhost.");
  }
  if (!path.startsWith("/api/")) throw new Error("Invalid dashboard API path");
  const headers = new Headers(init.headers);
  const response = await fetch(url.href, { ...init, ...PRIVATE_FETCH_OPTIONS, headers });
  if (!response.ok) {
    const error = new Error(`Dashboard API returned ${response.status}. Please try again.`);
    error.status = response.status;
    throw error;
  }
  return response.json();
}
